import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useIntl } from 'react-intl'
import ErrorTemplate from '../../organisms/error-template/error-template'
import Head from 'next/head'

const NoRoutePageComponent = () => {
	const { siteName, noRoute: { bgImage, bgImageMobile } = {} } = useConfig()
	const { formatMessage } = useIntl()

	return (
		<>
			<Head>
				<title>
					{formatMessage({ id: 'no_route_page_title_prefix', defaultMessage: '404 Not Found' }) +
						(siteName ? ' | ' + siteName : '')}
				</title>
			</Head>
			<ErrorTemplate
				bgImage={bgImage}
				bgImageMobile={bgImageMobile}
				message={formatMessage({ id: 'no_route_message', defaultMessage: 'This page could not be found' })}
				title={404}
			/>
		</>
	)
}

export default NoRoutePageComponent
